import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-job-des',
  templateUrl: './job-des.component.html',
  styleUrls: ['./job-des.component.scss'],
  standalone: false,
})
export class JobDesComponent implements OnInit {
  dialogData: any;

  constructor(
    private dialogRef: MatDialogRef<JobDesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.dialogData = data;
  }

  ngOnInit() {
    this.dialogData = this.data.jobData;
    console.log(this.dialogData);
  }
  onNoClick(): void {
    const data1 = {
      type: 'view', // Required. Type of interaction TOUCH,DRAG,DROP,PINCH,ZOOM,SHAKE,ROTATE,SPEAK,LISTEN,WRITE,DRAW,START,ENDCHOOSE,ACTIVATE,SHOW,HIDE,SCROLL,HEARTBEAT,OTHER
      subtype: '', // Optional. Additional types for a global type. For ex: for an audio the type is LISTEN and thesubtype can be one of PLAY,PAUSE,STOP,RESUME,END
      id: 'button', // Required. Resource (button, screen, page, etc) id on which the interaction happened - use systemidentifiers when reporting device events
      pageid: 'JobDescription', // Optional. Stage or page id on which the event happened
    };
    this.dialogRef.close(data1);
  }
}
